import {load} from "recaptcha-v3";

export default function getRecaptchaToken(action) {
    return new Promise((resolve, reject) => {
        load(window.config.RECAPTCHA_SITE_KEY).then((recaptcha) => {
            recaptcha.execute(action)
                .then((token) => {
                    return resolve(token);
                })
                .catch((error) => {
                    console.error(error)
                    reject(error)
                })
        })
    })
}
